'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateMinimumAuthState = exports.validateUpgradeProduct = exports.validatePurchaseConfig = exports.validatePurchaseableItemInConfig = exports.validateProductBasedOffers = exports.validateItemConfigurations = exports.validateCurrencyCode = exports.validateProductBasedOfferId = exports.validateMerchandiseId = exports.validateTermId = undefined;

var _helpers = require('self-service-api/core/utilities/helpers');

var _AuthStates = require('self-service-api/constants/AuthStates');

var _CurrencyCodes = require('self-service-api/constants/CurrencyCodes');

var CurrencyCodes = _interopRequireWildcard(_CurrencyCodes);

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var MerchandiseIds = _interopRequireWildcard(_MerchandiseIds);

var _TermIds = require('self-service-api/constants/TermIds');

var TermIds = _interopRequireWildcard(_TermIds);

var _UpgradeProducts = require('self-service-api/constants/UpgradeProducts');

var UpgradeProducts = _interopRequireWildcard(_UpgradeProducts);

var _ProductBasedOfferIds = require('self-service-api/constants/ProductBasedOfferIds');

var ProductBasedOfferIds = _interopRequireWildcard(_ProductBasedOfferIds);

var _ChargeTypes = require('self-service-api/constants/ChargeTypes');

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var currencyCodeValues = Object.values(CurrencyCodes || {});
var merchandiseIdValues = Object.values(MerchandiseIds || {});
var termIdValues = Object.values(TermIds || {});
var upgradeProductValues = Object.values(UpgradeProducts || {});
var productBasedOfferIdValues = Object.values(ProductBasedOfferIds || {});

var validateTermId = exports.validateTermId = function validateTermId(termId) {
  if (termId === null || termId === undefined) {
    return;
  }

  if (termIdValues.indexOf(termId) === -1) {
    throw new Error('Invalid termId, must be one of: ' + termIdValues);
  }
};

var validateMerchandiseId = exports.validateMerchandiseId = function validateMerchandiseId(merchandiseId) {
  if (merchandiseIdValues.indexOf(merchandiseId) === -1) {
    throw new Error('Invalid merchandiseId (' + merchandiseId + '), must be one of: ' + merchandiseIdValues);
  }
};

var validateProductBasedOfferId = exports.validateProductBasedOfferId = function validateProductBasedOfferId(productBasedOfferId) {
  if (productBasedOfferIdValues.indexOf(productBasedOfferId) === -1) {
    throw new Error('Invalid productBasedOfferId, must be one of: ' + productBasedOfferIdValues);
  }
};

var validateCurrencyCode = exports.validateCurrencyCode = function validateCurrencyCode(currencyCode) {
  if (currencyCodeValues.indexOf(currencyCode) === -1) {
    throw new Error('Invalid currencyCode, must be one of: ' + currencyCodeValues);
  }
};

var validateItemConfigurations = exports.validateItemConfigurations = function validateItemConfigurations(itemConfigurations) {
  if (itemConfigurations === null || itemConfigurations === undefined || Array.isArray(itemConfigurations) && !itemConfigurations.length) {
    return;
  }

  if (!Array.isArray(itemConfigurations)) {
    throw new Error('Invalid itemConfigurations: ' + JSON.stringify(itemConfigurations) + ', must be null, undefined, or an array');
  }

  itemConfigurations.forEach(function (itemConfiguration) {
    // The offer builder API uses the property name "id" but we enforce
    // "merchandiseId" for clarity and later transform it for the API
    validateMerchandiseId(itemConfiguration.merchandiseId);

    // The offer builder API supports null values for quantity and defaults
    // to 1 on the backend but we enforce the explicit passing of a value
    // for consistency on the front end.
    if (itemConfiguration.quantity === undefined || itemConfiguration.quantity === null) {
      throw new Error('Invalid itemConfiguration: ' + JSON.stringify(itemConfiguration) + ', must contain a quantity.');
    }

    if (!(0, _helpers.isInteger)(itemConfiguration.quantity)) {
      throw new Error('Invalid itemConfiguration: ' + JSON.stringify(itemConfiguration) + ', quantity must be an integer.');
    }
  });
};

var validateProductBasedOffers = exports.validateProductBasedOffers = function validateProductBasedOffers(productBasedOffers) {
  if (!Array.isArray(productBasedOffers)) {
    throw new Error('Invalid productBasedOffers: ' + JSON.stringify(productBasedOffers) + ', must be null, undefined, or an array');
  }

  productBasedOffers.forEach(function (productBasedOfferId) {
    validateProductBasedOfferId(productBasedOfferId);
  });
};

var validatePurchaseableItemInConfig = exports.validatePurchaseableItemInConfig = function validatePurchaseableItemInConfig(itemConfigurations, productBasedOffers) {
  if ((!itemConfigurations || !itemConfigurations.length) && (!productBasedOffers || !productBasedOffers.length)) {
    throw new Error('Invalid purchaseConfig, must have at least one itemConfiguration or productBasedOffer');
  }
};

var hasRecurringItems = function hasRecurringItems(itemConfigurations) {
  return itemConfigurations.some(function (_ref) {
    var merchandiseId = _ref.merchandiseId;

    return _ImmutableMerchandiseIdMap2.default[merchandiseId].chargeType === _ChargeTypes.RECURRING;
  });
};

var validatePurchaseConfig = exports.validatePurchaseConfig = function validatePurchaseConfig(_ref2) {
  var termId = _ref2.termId,
      currencyCode = _ref2.currencyCode,
      itemConfigurations = _ref2.itemConfigurations,
      productBasedOffers = _ref2.productBasedOffers;

  validateTermId(termId);
  validateCurrencyCode(currencyCode);
  validateItemConfigurations(itemConfigurations);
  if (productBasedOffers) {
    validateProductBasedOffers(productBasedOffers);
  }
  validatePurchaseableItemInConfig(itemConfigurations, productBasedOffers);

  if (hasRecurringItems(itemConfigurations) && !termId) {
    throw new Error('Must include a termId if your itemConfigurations contain a RECURRING item');
  }
};

var validateUpgradeProduct = exports.validateUpgradeProduct = function validateUpgradeProduct(upgradeProduct) {
  if (upgradeProductValues.indexOf(upgradeProduct) === -1) {
    throw new Error('Invalid upgradeProduct, must be one of: ' + upgradeProductValues);
  }
};

var validateMinimumAuthState = exports.validateMinimumAuthState = function validateMinimumAuthState(products, authState) {
  if (!products.authState) {
    throw new Error('Must use either getProducts or getProductsNoAuth in order to use this function');
  }

  if (authState === _AuthStates.AUTHED && products.authState !== _AuthStates.AUTHED) {
    throw new Error('You must use an authed response from getProducts in order to use this function.');
  }
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/core/validators.js
// module id = 59
// module chunks = 3 4 5